import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 1],
      rowsSize: [1, 3, 1],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:1": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Impedance and results",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-6.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>We have V<sub>b</sub> = 37 l
                  <li>The impedance curve gives:</br>f<sub>c</sub> = 34.3 Hz and</br>Q<sub>ec</sub> = 0.4
                  <li>Then V<sub>as</sub> =</br>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <mn>37</mn>
                  <mo>=</mo> <mo>(</mo>
                  <mfrac>
                  <mrow> <mn>34.3</mn> <mspace width="5px"/> <mo>x</mo> <mspace width="5px"/> <mn>34.3</mn> </mrow>
                  <mrow> <mn>20.8</mn> <mspace width="5px"/> <mo>x</mo> <mspace width="5px"/> <mn>0.24</mn> </mrow>
                  </mfrac> <mo>-</mo> <mn>1</mn> <mo>)</mo>
                  <mo>≃</mo> <mn>63.6</mn> <mspace width="5px"/> <mi>l</mi>
                  </math></br>
                  (manufacturer value: 60 l)
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                paddingTop: "15%",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
